var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1373_11699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 21.875C21.375 21.2563 20.8687 20.75 20.25 20.75L6.75 20.75C6.13125 20.75 5.625 21.2563 5.625 21.875C5.625 22.4938 6.13125 23 6.75 23L20.25 23C20.8688 23 21.375 22.4938 21.375 21.875ZM18.6637 11.75L16.875 11.75L16.875 6.125C16.875 5.50625 16.3687 5 15.75 5L11.25 5C10.6312 5 10.125 5.50625 10.125 6.125L10.125 11.75L8.33625 11.75C7.335 11.75 6.82875 12.965 7.5375 13.6738L12.7013 18.8375C13.14 19.2763 13.8488 19.2763 14.2875 18.8375L19.4512 13.6738C20.16 12.965 19.665 11.75 18.6637 11.75Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1373_11699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 27,
    fill: "white",
    transform: "translate(27 27.5) rotate(180)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.51e14796.svg";
export { ForwardRef as ReactComponent };